import api from '@/services/api';

class DashboardService {
  dashboard(params) {
    return api.get(`/dashboard`)
  }
}

export default new DashboardService();
